import { Dialog } from '@base-ui/react/dialog';

export type { Props as BackdropProps } from './components/Backdrop';
export { Backdrop } from './components/Backdrop';
export type { Props as ContentProps } from './components/Content';
export { Content } from './components/Content';
export type { Props as FooterProps } from './components/Footer';
export { Footer } from './components/Footer';
export type { Props as PopupProps } from './components/Popup';
export { Popup } from './components/Popup';
export type { Props as TitleProps } from './components/Title';
export { Title } from './components/Title';

const { Root, Trigger, Portal, Close } = Dialog;
export { Close, Portal, Root, Trigger };

export type RootProps = Dialog.Root.Props;
export type TriggerProps = Dialog.Trigger.Props;
